import { ErrorBoundary } from "@sentry/react";

export { ErrorBoundary };
